/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation MccDeleteManyMutation($mccIds: [ID!]!) {
  MccDeleteMany(mccIds: $mccIds) {
    message
    status
  }
}
`
